var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1C5.4087 1 3.88258 1.65555 2.75736 2.82245C1.63214 3.98934 1 5.57199 1 7.22222C1 11.5346 4.92272 15.2658 6.42457 16.5363C6.76052 16.8205 7.23948 16.8205 7.57543 16.5363C9.07728 15.2658 13 11.5346 13 7.22222C13 5.57199 12.3679 3.98934 11.2426 2.82245C10.1174 1.65555 8.5913 1 7 1ZM7.66237 14.077C7.29663 14.4469 6.70417 14.4461 6.33904 14.0756C4.69536 12.4078 2.71429 9.80471 2.71429 7.22222C2.71429 6.04348 3.16582 4.91302 3.96954 4.07953C4.77327 3.24603 5.86336 2.77778 7 2.77778C8.13664 2.77778 9.22673 3.24603 10.0305 4.07953C10.8342 4.91302 11.2857 6.04348 11.2857 7.22222C11.2857 9.81178 9.30577 12.415 7.66237 14.077Z",
    fill: "#027BFC",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.44434C8.10457 8.44434 9 7.54891 9 6.44434C9 5.33977 8.10457 4.44434 7 4.44434C5.89543 4.44434 5 5.33977 5 6.44434C5 7.54891 5.89543 8.44434 7 8.44434Z",
    fill: "#027BFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlue);
export default __webpack_public_path__ + "static/media/location_blue.447cf7c8c9d91013f6f4bc408a62381e.svg";
export { ForwardRef as ReactComponent };